import { useQuery } from '@tanstack/react-query';

import { catalogService } from '@/services/catalog-service';
import { isEmptyUUID, type UUID } from '@/utils/uuid';

import { catalogQueryKeys } from './query-keys';

export function useListCatalogEntities(tenantId?: UUID, connectorId?: UUID) {
  return useQuery({
    queryKey: catalogQueryKeys.entities(tenantId, connectorId),
    queryFn: async () => {
      if (isEmptyUUID(tenantId) || isEmptyUUID(connectorId)) {
        return [];
      }

      return catalogService.listEntities(tenantId!, connectorId!);
    },
    // The nil UUID (returned by useCurrentTenantID while the tenant query is
    // still loading) is a non-empty string, so a `!!tenantId` gate would fire a
    // request against /tenants/00000000-… (500s, then triggers retry storms
    // that drain the shared rate-limit bucket). Gate on a real tenant/connector.
    enabled: !isEmptyUUID(tenantId) && !isEmptyUUID(connectorId),
    // Entity kinds are effectively static for a connector; cache them so
    // navigating away and back reuses real data instead of refiring the
    // query (which can be rejected by the client-side rate limiter and then
    // cached as an empty result). See docs/eventual-consistency.md.
    staleTime: 5 * 60_000,
  });
}
